export interface ReferralCookieData {
  code: string;
  name?: string;
  source?: string;
}

export const REFERRAL_COOKIE_NAME = 'referral_data';
export const REFERRAL_COOKIE_EXPIRATION_HOURS = 72;
